import React from 'react';

export interface IStepper {
    step: number;
    first: VoidFunction
    next: VoidFunction
    prev: VoidFunction
    jump: (to: number) => void;    
}

export function useStepper(initialValue: number = 0) : IStepper {
    const [step, setStep] = React.useState(initialValue);

    const first = React.useCallback(() => {
        setStep(0);
    }, []);

    const next = React.useCallback(() => {
        setStep(s => s + 1);
    }, []);

    const prev = React.useCallback(() => {
        setStep(s => s - 1);
    }, []);

    const jump = React.useCallback((to: number) => {
        setStep(to);
    }, []);

    return React.useMemo(() => ({
        first, step, next, prev, jump
    }), [first, step, next, prev, jump]);
}